import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { OpenAPI, verifyMagicLinkApiV1LoginVerifyMagicLinkPost } from "@/client";
import { OpenAPI as OpenAPIAdmin } from "@/client-admin";
import { checkIsSuperuser, getRedirectPath } from "@/lib/utils";

const verifyMagicLinkSchema = z.object({
  token: z.string(),
});

export const Route = createFileRoute("/verify-magic-link")({
  validateSearch: verifyMagicLinkSchema,
  beforeLoad: async ({ search }) => {
    const { token } = search;
    if (!token) {
      throw redirect({ to: "/login" });
    }
  },
  component: () => null,
  loaderDeps: ({ search: { token } }) => ({ token }),
  loader: async ({ deps: { token } }) => {
    let response;
    try {
      response = await verifyMagicLinkApiV1LoginVerifyMagicLinkPost({ requestBody: { token } });
    } catch {
      throw redirect({ to: "/error-auth" });
    }

    localStorage.setItem("access_token", response.access_token);
    OpenAPI.TOKEN = response.access_token;

    const isSuperuser = checkIsSuperuser();

    if (isSuperuser) {
      OpenAPIAdmin.TOKEN = response.access_token;
    }

    throw redirect({ to: getRedirectPath() });
  },
});
